/** =========================================================
 * Module: navbar-search.js
 * Navbar search toggler * Auto dismiss on ESC key
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.navsearch')
    .directive('searchOpen', searchOpen)
    .directive('searchDismiss', searchDismiss);

  //
  // directives definition
  //

  function searchOpen() {
    var directive = {
      controller: searchOpenController,
      restrict: 'A'
    };
    return directive;
  }

  function searchDismiss() {
    var directive = {
      controller: searchDismissController,
      restrict: 'A'
    };
    return directive;
  }

  //
  // Contrller definition
  //

  searchOpenController.$inject = ['$rootScope', '$scope', '$element', 'NavSearch'];

  function searchOpenController($rootScope, $scope, $element, NavSearch) {
    $element
      .on('click', function (e) {
        e.stopPropagation();
      })
      .on('click', NavSearch.toggle);
  }

  searchDismissController.$inject = ['$rootScope', '$scope', '$element', 'NavSearch'];

  function searchDismissController($rootScope, $scope, $element, NavSearch) {
    var inputSelector = '.navbar-form input[type="text"]';

    var globalTimeout = null;

    $(inputSelector)
      .on('click', function (e) {
        e.stopPropagation();
      })
      .on('keydown', function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();

          if (globalTimeout !== null) {
            clearTimeout(globalTimeout);
          }

          search();
        }
      })
      .on('keyup', function (e) {
        if (e.keyCode === 27) {
          NavSearch.dismiss();
        }

        if (globalTimeout !== null) {
          clearTimeout(globalTimeout);
        }

        globalTimeout = setTimeout(search, 500);
      });

    function search() {
      globalTimeout = null;

      if (NavSearch.isOpen() && $rootScope.activeTableConfig) {
        var searchValue = $(inputSelector).val();

        if ($scope.request && $scope.request.cancel) {
          $scope.request.cancel();
        }

        $rootScope.activeTableConfig.getDataParams.page = 1;
        $rootScope.activeTableConfig.getDataParams.search = searchValue;
        $scope.request = $rootScope.activeTableConfig.getData();
      }
    }

    // click anywhere closes the search
    $(document).on('click', NavSearch.dismiss);
    // dismissable options
    $element
      .on('click', function (e) {
        e.stopPropagation();
      })
      .on('click', NavSearch.dismiss);
  }
})();
